/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from "react";

// Custom hook to determine if an element is intersecting with the viewport
export const useIsIntersecting = (
  elementRef, // Reference to the DOM element
  {
    threshold = 0, // Threshold(s) at which to trigger the callback
    root = null, // Root element for intersection checking
    rootMargin = "0%", // Margin around the root for intersection detection
    freezeOnceVisible = false, // Whether to stop observing once element is intersecting
    skip = false, // Whether to skip intersection checking
  }
) => {
  const [isIntersecting, setIntersecting] = useState(false);

  const frozen = isIntersecting && freezeOnceVisible;

  const stringifiedThreshold = JSON.stringify(threshold); // Stringify the threshold to use as dependency in useEffect

  const observerCallback = ([entries]) => {
    setIntersecting(entries.isIntersecting);
  };

  useEffect(() => {
    const node = elementRef?.current; // DOM Ref
    const hasIntersectionObserverSupport = !!window.IntersectionObserver;

    if (!hasIntersectionObserverSupport || frozen || !node || skip) return;

    const observerParams = { threshold, root, rootMargin };
    const observer = new IntersectionObserver(observerCallback, observerParams);
    observer.observe(node);

    return () => observer.disconnect();
  }, [elementRef?.current, stringifiedThreshold, root, rootMargin, frozen]);

  return isIntersecting;
};
